import { Component, Input } from '@angular/core';

@Component({
	selector: 'button-primary',
	template: require('./button-primary.component.html'),
})
export class ButtonPrimaryComponent {
	@Input() title: string;
	@Input() size: string;
	@Input() isDisabled: boolean;
	@Input() isWhite: boolean;
	@Input() fillSpaceMobile = false;
	@Input() fillSpace = false;
	@Input() otherClass = false;
	buttonClass: string;

	ngOnInit() {
		this.buttonClass = this.isWhite ? 'button-white' : 'button';
	}
}
